/** The account a dialog acts on: its notation, label, currency and state. */
import { useFeatureTranslation } from '@/hooks/useFeatureTranslation';
import type { PartyBankAccount } from '../hooks/use-party-bank-accounts';
import { formatBankAccountNumber, secondaryIban } from '../utils/format-bank-account';
import { BankAccountStateBadge } from './BankAccountStateBadge';

interface BankAccountSummaryProps {
  account: PartyBankAccount;
}

export function BankAccountSummary({ account }: BankAccountSummaryProps) {
  const t = useFeatureTranslation('partyBankAccounts.row');
  const iban = secondaryIban(account);
  const facts = [account.label, account.currencyCode ?? t('anyCurrency')].filter(Boolean);

  return (
    <div className='flex flex-wrap items-start justify-between gap-sm rounded-lg bg-background-muted px-md py-sm'>
      <div className='min-w-0'>
        <p className='font-mono tabular-nums text-sm font-medium text-foreground-base break-all'>
          {formatBankAccountNumber(account)}
        </p>
        {iban && (
          <p className='font-mono tabular-nums text-xs text-foreground-muted break-all'>
            {t('iban', { iban })}
          </p>
        )}
        <p className='text-xs text-foreground-muted'>{facts.join(' · ')}</p>
      </div>
      <BankAccountStateBadge state={account.verificationState} />
    </div>
  );
}
